import { addSharingLink } from 'owa-link-data';
import { preloadAttachmentBlockOnSend } from 'owa-attachment-block-on-send';
import { orchestrator } from 'satcheljs';

orchestrator(addSharingLink, actionMessage => {
    preloadAttachmentBlockOnSend.import();
});
